import axios from "axios";
import { baseUrl } from "../baseUrl/BaseUrl";

// Créez un nouvel objet Axios avec les configurations de base
const axiosInstance = (accessToken) => {
    const config = {
        baseURL: baseUrl,
        withCredentials: false,
        headers: {
            Accept: "application/json",
        },
    };

    // Only set Authorization header when an accessToken is provided.
    // Avoid sending an empty Authorization header which some backends treat as an invalid token (403).
    if (accessToken) {
        // Use Bearer scheme unless your backend expects a different format
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    const axiosInst = axios.create(config);

    // Interceptors can be added here if needed (logging, token refresh, etc.)

    return axiosInst;
};

export default axiosInstance;